//Constants for getting type references
export { LoginPage } from './login/login';
export { TabsPage } from './tabs/tabs';
export { HomePage } from './home/home';
export { HomeTCPage } from './team-challenge/home-tc/home-tc';
export { HomePCPage } from './personal-challenge/home-pc/home-pc';
export { AchievementsPage } from './achievements/achievements';
export { CargadorTcPage } from './team-challenge/cargador-tc/cargador-tc';
export { ResultadoTcPage } from './team-challenge/resultado-tc/resultado-tc';
export { RetoTcPage } from './team-challenge/reto-tc/reto-tc';
export { CargadorPcPage } from './personal-challenge/cargador-pc/cargador-pc';
export { ResultadoPcPage } from './personal-challenge/resultado-pc/resultado-pc';
export { RetoPcPage } from './personal-challenge/reto-pc/reto-pc';
export { PerfilPage } from './perfil/perfil';
export { BuscarTcPage } from './team-challenge/buscar-tc/buscar-tc';
export { FortalezasDebilidadesPage } from './fortalezas-debilidades/fortalezas-debilidades';
export { RecuperarContraseniaPage } from './recuperar-contrasenia/recuperar-contrasenia';
export { LeaderboardPage } from './leaderboard/leaderboard';
export { VsPage } from './vs/vs';
export { DetalleRondaPage } from './detalle-ronda/detalle-ronda';
export { HistoricoRetosPage } from './historico-retos/historico-retos';
export { NuevaCampaniaPage } from './nueva-campania/nueva-campania';
export { FinCampaniaPage } from './fin-campania/fin-campania';
export { BusquedaTesoroPage } from './busqueda-tesoro/busqueda-tesoro';
export { BusquedaTesoroNivelesPage } from './busqueda-tesoro-niveles/busqueda-tesoro-niveles';
export { BusquedaTesoroInstruccionesPage } from './busqueda-tesoro-instrucciones/busqueda-tesoro-instrucciones';
export { BusquedaTesoroNivelDetallePage } from './busqueda-tesoro-nivel-detalle/busqueda-tesoro-nivel-detalle';
export { BusquedaTesoroPreguntaPage } from './busqueda-tesoro-pregunta/busqueda-tesoro-pregunta';
export { BusquedaTesoroResultadoRondaPage } from './busqueda-tesoro-resultado-ronda/busqueda-tesoro-resultado-ronda';
export { BusquedaTesoroCofrePage } from './busqueda-tesoro-cofre/busqueda-tesoro-cofre';
export { NotificacionesPage } from './notificaciones/notificaciones';
export { MaterialesApoyoPage } from './materiales-apoyo/materiales-apoyo';
export { MaterialApoyoDetallePage } from './material-apoyo-detalle/material-apoyo-detalle';
export { VideoPlayerPage } from './video-player/video-player';
export { ChagePasswordPage } from './chage-password/chage-password';
export { InfoBotsPage } from './info-bots/info-bots';
export { ResultadoBotPage } from './personal-challenge/resultado-bot/resultado-bot';
export { OnboardingPage } from './onboarding/onboarding';

// Modulos
export { CargadorTcPageModule } from './team-challenge/cargador-tc/cargador-tc.module';
export { ResultadoTcPageModule } from './team-challenge/resultado-tc/resultado-tc.module';
export { RetoTcPageModule } from './team-challenge/reto-tc/reto-tc.module';
export { CargadorPcPageModule } from './personal-challenge/cargador-pc/cargador-pc.module';
export { ResultadoPcPageModule } from './personal-challenge/resultado-pc/resultado-pc.module';
export { RetoPcPageModule } from './personal-challenge/reto-pc/reto-pc.module';
export { PerfilPageModule } from './perfil/perfil.module';
export { BuscarTcPageModule } from './team-challenge/buscar-tc/buscar-tc.module';
export { FortalezasDebilidadesPageModule } from './fortalezas-debilidades/fortalezas-debilidades.module';
export { RecuperarContraseniaPageModule } from './recuperar-contrasenia/recuperar-contrasenia.module';
export { LeaderboardPageModule } from './leaderboard/leaderboard.module';
export { VsPageModule } from './vs/vs.module';
export { DetalleRondaPageModule } from './detalle-ronda/detalle-ronda.module';
export { HistoricoRetosPageModule } from './historico-retos/historico-retos.module';
export { NuevaCampaniaPageModule } from './nueva-campania/nueva-campania.module';
export { FinCampaniaPageModule } from './fin-campania/fin-campania.module';
export { BusquedaTesoroPageModule } from './busqueda-tesoro/busqueda-tesoro.module';
export { BusquedaTesoroNivelesPageModule } from './busqueda-tesoro-niveles/busqueda-tesoro-niveles.module';
export { BusquedaTesoroInstruccionesPageModule } from './busqueda-tesoro-instrucciones/busqueda-tesoro-instrucciones.module';
export { BusquedaTesoroNivelDetallePageModule } from './busqueda-tesoro-nivel-detalle/busqueda-tesoro-nivel-detalle.module';
export { BusquedaTesoroPreguntaPageModule } from './busqueda-tesoro-pregunta/busqueda-tesoro-pregunta.module';
export { BusquedaTesoroResultadoRondaPageModule } from './busqueda-tesoro-resultado-ronda/busqueda-tesoro-resultado-ronda.module';
export { BusquedaTesoroCofrePageModule } from './busqueda-tesoro-cofre/busqueda-tesoro-cofre.module';
export { NotificacionesPageModule } from './notificaciones/notificaciones.module';
export { MaterialesApoyoPageModule } from './materiales-apoyo/materiales-apoyo.module';
export { MaterialApoyoDetallePageModule } from './material-apoyo-detalle/material-apoyo-detalle.module';
export { VideoPlayerPageModule } from './video-player/video-player.module';
export { ChagePasswordPageModule } from './chage-password/chage-password.module';
export { InfoBotsPageModule } from './info-bots/info-bots.module';
export { ResultadoBotPageModule } from './personal-challenge/resultado-bot/resultado-bot.module';
export { OnboardingPageModule } from './onboarding/onboarding.module';


// WEBPACK FOOTER //
// ./src/pages/index.ts